import React from 'react';
import { cleanLinkSrc } from '../../../components/Viewer/useHandlers';
import { EXTENSION_TYPE_NAME } from '../constants';
const Viewer = ({ node })=>{
    const { attrs } = node;
    const url = cleanLinkSrc((attrs === null || attrs === void 0 ? void 0 : attrs.url) || '', [
        'giphy.com'
    ]);
    return /*#__PURE__*/ React.createElement("div", null, attrs && url && /*#__PURE__*/ React.createElement("video", {
        "data-da-type": EXTENSION_TYPE_NAME,
        width: attrs.width || 'auto',
        height: attrs.height || 'auto'
    }, /*#__PURE__*/ React.createElement("source", {
        src: url
    })));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map